/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable no-nested-ternary */
import React, { ReactElement } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Box } from 'components';
import './formCompanySelectModal.scss';

interface Props {
  users: Array<{
    id: number;
    companyName: string;
    firstName: string;
    lastName: string;
  }>;
  selectedId: number | null;
  onSelect: (id: number) => void;
}

const FormBlackPointAccident = (props: Props): ReactElement => {
  const { users, selectedId, onSelect } = props;
  const { t } = useTranslation('layout');

  return (
    <Box
      id="companySelectUserModalFormBox"
      name={t('userPulpitChange.changeOfCompany')}
      svgIcon="addEdit"
      noMarginBottom
      noShadow
    >
      <div className="companySelectFormBox">
        <div className="companySelectContentForm">
          <h3>Wybierz</h3>

          <div className="companySelectContentDetailForm">
            {users.map((u) => (
              <Button
                key={u.id}
                type="button"
                onClick={() => onSelect(u.id)}
                style={{
                  padding: '8px 10px',
                  borderRadius: 8,
                  border: '1px solid #ccc',
                  background: u.id === selectedId ? '#e6f0ff' : '#fff',
                  fontWeight: u.id === selectedId ? 600 : 400,
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                {`${u.firstName} ${u.lastName} - ${u.companyName}`}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default FormBlackPointAccident;
